export enum PlasticsFinishingTaskStatus {
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
}